import sizes from "./sizes";
import bg from './bg.svg';
const styles = {
  "@global": {
    ".fade-exit": {
      opacity: 1
    },
    ".fade-exit-active": {
      opacity: 0,
      transition: "opacity 500ms ease-out"
    }
  },
  root: {
    height: '100vh',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    backgroundImage: `url(${bg})`,
    /* background by SVGBackgrounds.com */
    overflow: "scroll"
  },
  container: {
    width: '50%',
    display: 'flex',
    alignItems: 'flex-start',
    flexDiretion: 'column',
    flexWrap: 'wrap',
    [sizes.down("xl")]: {
      width: "80%"
    },
    [sizes.down("xs")]: {
      width: "75%"
    }
  },
  nav: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'black',
    "& a": {
      color: 'black'
    }
  },
  heading: {
    fontSize: "2rem"
  },
  palettes: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 30%)',
    gridGap: '2.5rem',
    [sizes.down("md")]: {
      gridTemplateColumns: 'repeat(2, 50%)',
    },
    [sizes.down("xs")]: {
      gridTemplateColumns: 'repeat(1, 100%)',
      gridGap: '1rem',
    }
  }
};

export default styles;